import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _getItems = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/items?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/items/v2`


  return Request.get(
    url,
    config
  )
}

const _getItemsCategories = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/items/categories?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/items/categories`


  return Request.get(
    url,
    config
  )
}

const _getItemsOfflineSources = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/items/offline-sources?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/items/offline-sources`


  return Request.get(
    url,
    config
  )
}

const _getItemsOfflineCategories = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/items/offline-categories?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/items/offline-categories`


  return Request.get(
    url,
    config
  )
}

const _getItemsOfflineBrands = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/items/offline-brands?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/items/offline-brands`


  return Request.get(
    url,
    config
  )
}

const _getItemsOfflinePaymentMethods = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/items/offline-payment-methods?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/items/offline-payment-methods`


  return Request.get(
    url,
    config
  )
}

const _getItemsFilterCount = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    },
    timeout: 10000
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/items/filter-count`,
    payload,
    config
  )
}

const _updateItem = (product) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/items/${product._id}`, product, config)
}

// Inspección read-only del catálogo (admin-apis item.inspection.controller).
const _getItemsInspection = (path, query) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/items/inspection/${path}?${query}`, config)
}

export default {
  getItems : _getItems,
  updateItem: _updateItem,
  getItemsCategories: _getItemsCategories,
  getItemsOfflineSources: _getItemsOfflineSources,
  getItemsOfflineCategories: _getItemsOfflineCategories,
  getItemsOfflineBrands: _getItemsOfflineBrands,
  getItemsOfflinePaymentMethods: _getItemsOfflinePaymentMethods,
  getItemsFilterCount: _getItemsFilterCount,
  getItemsInspection: _getItemsInspection
}
